export interface PaymentTermsSection {
  title: string;
  paragraphs?: string[];
  bullets?: string[];
}

export const PAYMENT_TERMS_TITLE = 'Порядок оказания услуг, оплаты и возврата';
export const PAYMENT_TERMS_SUBTITLE = 'Информация для пользователей перед оплатой доступа';

export const PAYMENT_TERMS_SECTIONS: PaymentTermsSection[] = [
  {
    title: 'Порядок оказания услуги',
    bullets: [
      'Услуга заключается в предоставлении пользователю цифрового доступа к выбранному клубу и его материалам в сервисе INHOUND.',
      'После подтверждённой оплаты доступ к клубу открывается автоматически в аккаунте пользователя, с которого оформлена покупка.',
      'Если доступ не открылся автоматически, пользователь может обратиться на info@inhound.club, и мы проверим статус оплаты и доступ вручную.',
    ],
  },
  {
    title: 'Условия оплаты',
    bullets: [
      'Стоимость доступа указывается на странице оплаты до подтверждения платежа.',
      'Оплата производится в безналичном порядке через подключённый платёжный сервис.',
      'В рамках текущей версии сервиса расчёты производятся в рублях Российской Федерации.',
      'Обязанность по оплате считается исполненной после получения Исполнителем подтверждения успешного платежа от платёжного партнёра.',
    ],
  },
  {
    title: 'Условия возврата денежных средств',
    bullets: [
      'Пользователь вправе направить заявку на возврат денежных средств в течение 14 календарных дней с даты оплаты на e-mail info@inhound.club.',
      'В заявке достаточно указать e-mail аккаунта, дату оплаты и краткое описание причины обращения.',
      'При рассмотрении заявки Исполнитель вправе удержать сумму пропорционально уже предоставленному и фактически использованному доступу к контенту, а также фактически понесённые расходы, связанные с исполнением обязательств перед пользователем.',
      'Решение по заявке и, при наличии оснований, порядок возврата сообщаются пользователю по электронной почте.',
    ],
  },
];
